export default __webpack_public_path__ + "384f7d1aaf5d35a6f46637169a34d8a7.png";